// src/utils/recentlyViewed.js
const KEY = "recentlyViewed";

const safeJson = (v, fallback) => {
  try {
    return JSON.parse(v);
  } catch {
    return fallback;
  }
};

const getFirstImageUrl = (images) => {
  if (!images) return "";
  if (Array.isArray(images)) {
    const first = images[0];
    if (!first) return "";
    if (typeof first === "string") return first;
    return first?.url || "";
  }
  return "";
};

export const readRecentlyViewed = () => {
  const raw = localStorage.getItem(KEY);
  const arr = safeJson(raw || "[]", []);
  return Array.isArray(arr) ? arr : [];
};

export const pushRecentlyViewed = (product) => {
  if (!product) return;

  const id = product?._id || product?.id;
  if (!id) return;

  const slug = String(product?.slug || "").trim();

  const item = {
    id: String(id),
    _id: String(id),

    // ✅ slug support
    slug: slug || "",
    productSlug: slug || "",

    name: product?.title || product?.name || "Product",
    title: product?.title || product?.name || "Product",

    img: getFirstImageUrl(product?.images) || product?.image || "",
    price: product?.price ?? 0,
    oldPrice:
      product?.oldPrice !== undefined && product?.oldPrice !== null
        ? product.oldPrice
        : product?.discountedPrice && Number(product?.price) > Number(product?.discountedPrice)
        ? product.price
        : null,

    rating: Number(product?.totalrating || product?.rating || 0),
    viewedAt: Date.now(),
  };

  const prev = readRecentlyViewed();

  // remove duplicates, keep newest first
  const next = [
    item,
    ...prev.filter((x) => String(x?.id || x?._id || x?.productId) !== String(id)),
  ].slice(0, 12);

  localStorage.setItem(KEY, JSON.stringify(next));

  // ✅ VERY IMPORTANT: tell pages to refresh immediately
  window.dispatchEvent(new Event("recentlyViewedUpdated"));
};